module.exports = __webpack_public_path__ + "img/Plus.9b607b05.svg";